import React, { useRef, useImperativeHandle, forwardRef, memo } from 'react'
import { Toaster, Position, Intent } from '@blueprintjs/core'
const BPToast = forwardRef((props, ref) => {
  const toastRef = useRef()
  useImperativeHandle(ref, () => ({
    showMessage(data) {
      toastRef.current.show({
        message: data.message,
        intent: data.intent || Intent.SUCCESS,
        timeout: data.timeout || 2000,
        icon: data.icon || 'tick',
      })
    },
  }))
  return (
    <Toaster className='bp-toast-comp' ref={toastRef} usePortal={props.usePortal || false} position={props.position || Position.BOTTOM} />
  )
})
export default memo(BPToast)
